import { render } from "./UserChat.vue?vue&type=template&id=520e0015&scoped=true"
import script from "./UserChat.vue?vue&type=script&lang=js"
export * from "./UserChat.vue?vue&type=script&lang=js"

import "./UserChat.vue?vue&type=style&index=0&id=520e0015&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-520e0015"]])

export default __exports__